import { useQuery } from '@apollo/client';
import { GET_RELEASES_STATS } from '../guides/guide.graphql';
import { StyledPaper, theme } from '../theme';
import { Typography } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import React from 'react';
import LoadingSpinner from '../LoadingSpinner';

export function ReleasesStats() {
  const { data, loading } = useQuery(GET_RELEASES_STATS);

  return (
    <StyledPaper>
      <Typography style={{ fontSize: 18 }}>Publiserte anvisninger {!loading && `(${data.stats.publishedGuides})`}</Typography>
      {loading && <LoadingSpinner />}
      {data && (
        <>
          <PieChart
            sx={{ mt: 1 }}
            series={[
              {
                data: [
                  { id: 0, value: data.stats.publishedGuidesWithCms, label: 'CMS' },
                  { id: 1, value: data.stats.publishedGuides - data.stats.publishedGuidesWithCms, label: 'Word' },
                ],
              },
            ]}
            colors={[theme.palette.success.light, theme.palette.primary.main]}
            height={250}
          />
        </>
      )}
    </StyledPaper>
  );
}
